import React, { useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Button, TextField } from "react-md";
import { MDialog, MSelect } from "components/Shared";
import responseHandler from "responseHandler";

function AssignedAppraiserAuditPopup({
  submitAssignedAppraiserReason,
  makeToast,
  proximityCommentNeeded,
  assignedReasonNeeded,
  licenseCommentNeeded,
}) {
  const [showOtherCommentField, setShowOtherCommentField] = useState(false);
  const [selectedReason, setSelectedReason] = useState(null);
  const [assignComment, setAssignComment] = useState(null);
  const [proximityComment, setProximityComment] = useState(null);
  const [licenseComment, SetLicenseComment] = useState(null);

  const onSelectedReasonChange = (option) => {
    if (option?.value === "Other") {
      setShowOtherCommentField(true);
    } else setShowOtherCommentField(false);
    setSelectedReason(option.value);
  };

  const onSubmit = () => {
    if ((assignedReasonNeeded && selectedReason === "Other" && (assignComment === null || !/[a-zA-Z]/.test(assignComment)))
      || (proximityCommentNeeded && (proximityComment === null || !/[a-zA-Z]/.test(proximityComment)))
      || (licenseCommentNeeded && (licenseComment === null || !/[a-zA-Z]/.test(licenseComment)))) {
      makeToast("Please leave a comment before submitting.");
    } else if (assignedReasonNeeded && !selectedReason) {
      makeToast("Please select a reason.");
    } else {
      submitAssignedAppraiserReason(selectedReason, assignComment, proximityComment, licenseComment);
    }
  };

  const assignedAppraiserReasons = ["Available capacity", "Ability to meet Customer due date", "Previously appraised subject property", "Other"]
    .map(aa => ({ label: aa, value: aa }));

  return (
    <MDialog
      id={"assigned-appraiser-dialog"}
      className={"assigned-appraiser-dialog"}
      title={"Assignment Details"}
      focusOnMount={true}
      width={525}
    >
      {assignedReasonNeeded && <div className={"select-container"}>
        <h6 className={"assignment-reason-label"}>Explain why lower rated appraiser was assigned: </h6>
        <MSelect
          id={"assigned-appraiser-dropdown"}
          className={"assignment-reason-dropdown"}
          options={assignedAppraiserReasons}
          isClearable={false}
          onChange={onSelectedReasonChange}
          getMenuPortalTarget={() => document.querySelector(".assigned-appraiser-dialog")}
        />
      </div>}
      {showOtherCommentField && <TextField
        id={"assigned-appraiser-comment"}
        label={"Insert Comment:"}
        maxLength={500}
        onChange={(newComment) => setAssignComment(newComment)}
        required
      />}
      {proximityCommentNeeded && <>
        {/* This is an h6 to match MSelect label styles above */}
        <h6>Explain why Appraiser more than 150 miles was assigned:</h6>
        <TextField
          id={"appraiser-proximity-comment"}
          label={"Insert Comment:"}
          maxLength={500}
          onChange={(newComment) => setProximityComment(newComment)}
          required
        />
      </>}
      {licenseCommentNeeded && <>
        <h6>Explain why Appraiser with expiring license was assigned:</h6>
        <TextField
          id={"appraiser-proximity-comment"}
          label={"Insert Comment:"}
          maxLength={500}
          onChange={(newComment) => SetLicenseComment(newComment)}
          required
        />
      </>}
      <Button
        primary
        raised
        onClick={onSubmit}
      >
        Submit
      </Button>
    </MDialog>
  );
}


AssignedAppraiserAuditPopup.propTypes = {
  submitAssignedAppraiserReason: PropTypes.func,
  makeToast: PropTypes.func,
  proximityCommentNeeded: PropTypes.bool,
  assignedReasonNeeded: PropTypes.bool,
  licenseCommentNeeded: PropTypes.bool,
};

const mapDispatchToProps = (dispatch) => ({
  makeToast(text, type) {
    responseHandler.customToast(text, type, dispatch);
  }
});

export default connect(null, mapDispatchToProps)(AssignedAppraiserAuditPopup);
